import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {OptionService} from '../../../Services/option.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import * as _ from 'lodash';
import {ProductService} from '../../../Services/product.service';

@Component({
  selector: 'app-option-overview',
  templateUrl: './option-overview.component.html',
  styleUrls: ['./option-overview.component.scss']
})
export class OptionOverviewComponent implements OnInit {

  @ViewChild('optionsRowDetail', {static: false}) optionsRowDetail: any;
  public grid: Grid;
  public optionId: number;
  public optionName: string;

  public dataArray;
  public unionName;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('activeModels', {static: false}) activeModels = null;
  @ViewChild('modelTooltip', {static: true}) modelTooltip = null;

  constructor(
    private router: Router,
    private optionService: OptionService,
    private translateService: TranslateService,
    private broadCastService: BroadcastService,
    private productService: ProductService
  ) {
  }

  ngOnInit() {

    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.option.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          minWidth: 200,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.option.system_description',
          prop: 'systemDescription',
          sortable: true,
          type: TextColumn.type,
          minWidth: 240,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.option.active_modals',
          prop: 'optionProducts',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.modelTooltip,
        },
        <TextColumn>{
          name: 'doctrine.option.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <NumberColumn>{
          name: 'doctrine.option.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.optionService.setPosition(position, row.id).subscribe((res) => {
              this.broadCastService.broadcast('refreshGrid', 'getOption');

            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/option/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/option/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.optionId = row.id;
                this.optionName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.optionService,
      rememberURL: this.router.url,
      method: 'getOption',
      defaultSort: 'position',
      rowDetailTemplate: this.optionsRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'model_id',
          type: 'ng-select',
          label: 'doctrine.option.product_modal',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          value: new ServiceSearchItem(this.productService, 'getModals', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translateService.instant('global.all')});
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
    };

  }

  softDelete() {
    this.optionService.softDeleteOption(this.optionId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getOption');
    });
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/option/archive');

  }

  calcModel(row) {
    const union = _.unionBy(row.optionProducts, (item) => item['model'].id);
   // @ts-ignore
    this.dataArray = union.filter(item => !item.deleted);
   return true;
  }

}
